export default __webpack_public_path__ + "static/media/Greenindicator.003ec6fd.svg";